import * as React from "react";
import { useRef, useState } from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { UploadList } from "./UploadList";
import "./Upload.scss";

const acceptTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/pdf",
    "application/gpx+xml",
    "application/zip",
    "application/vnd.etsi.asic-e+zip",
    "application/vnd",
    "application/edoc",
    "image/png",
    "image/jpg",
    "image/jpeg",
    ".gpx",
    ".kml",
    ".kmz",
    ".edoc",
    ""
];
const allowedTypes = new Set(acceptTypes);

export const Upload = (): JSX.Element => {
    const { attachments, setAttachments } = useRegistrationContext();
    const [uploadList, setUploadList] = useState<FileList>(attachments);

    const inputRef = useRef();

    const onAdd = (e) => {
        const selectedFiles: FileList = e.target.files;
        if (!selectedFiles.length || !inputRef.current) {
            return;
        }

        const dt = new DataTransfer();

        const addFile = (file: File) => {
            if (!file.type) {
                dt.items.add(addFileType(file));
                return;
            }
            if (!allowedTypes.has(file.type)) {
                e.preventDefault();
                return;
            }
            dt.items.add(file);
        };

        if (uploadList && uploadList.length) {
            Array.from(uploadList).map((file) => {
                addFile(file);
            });
        }

        Array.from(selectedFiles).map((file) => {
            !uploadList || !uploadList.length
                ? addFile(file)
                : !Array.from(uploadList).find((f) => f.name === file.name) && addFile(file);
        });

        onChangeList(dt.files);
    };

    const onChangeList = (list: FileList) => {
        (inputRef.current as HTMLInputElement).files = list;
        setUploadList(list);
        setAttachments(list);
    };

    return (
        <div className="upload-component">
            <div className="upload-button">
                <label className="upload-button-label" htmlFor="attachments">
                    <a role="button" aria-disabled="false">
                        + Pievienot
                    </a>
                </label>
                <input
                    ref={inputRef}
                    className="file-input-element"
                    type="file"
                    id="attachments"
                    name="attachments"
                    onChange={onAdd}
                    multiple
                    accept={acceptTypes.join(",")}
                />
            </div>
            <UploadList onChange={onChangeList} fileList={uploadList}></UploadList>
        </div>
    );
};

const addFileType = (file: File): File => {
    const extension = file.name.split(".")[1];
    return new File([file], file.name, {
        type:
            extension === "kml"
                ? "application/vnd.google-earth.kml+xml"
                : extension === "kmz"
                ? "application/vnd.google-earth.kmz"
                : extension === "gpx"
                ? "application/gpx+xml"
                : ""
    });
};
